/**
 * @generated SignedSource<<48c6b040d4ef7d1b18e3bf4b07768991>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audioBase64"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audioContentType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audioBase64",
        "variableName": "audioBase64"
      },
      {
        "kind": "Variable",
        "name": "audioContentType",
        "variableName": "audioContentType"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "concreteType": "TranscribeAudioPayload",
    "kind": "LinkedField",
    "name": "transcribeAudio",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transcription",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscribeAudioMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TranscribeAudioMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b8b4114e9280a2d343dfd4459ad01886",
    "id": null,
    "metadata": {},
    "name": "TranscribeAudioMutation",
    "operationKind": "mutation",
    "text": "mutation TranscribeAudioMutation(\n  $resourceId: ID!\n  $audioBase64: String!\n  $audioContentType: String\n) {\n  transcribeAudio(resourceId: $resourceId, audioBase64: $audioBase64, audioContentType: $audioContentType) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    transcription\n  }\n}\n"
  }
};
})();

node.hash = "fcdf5253603c44441654c269a6cabfb4";

module.exports = node;
